var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPartner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 682.667 682.667",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 512h512V0H0Z",
    fill: "#ffffff",
    "data-original": "#000000",
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.33333 0 0 -1.33333 0 682.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-82.921-47.875c-14.349-8.284-32.696-3.367-40.981 10.981-8.285 14.349-3.368 32.697 10.981 40.981L-7.902 64.72a40.002 40.002 0 0 0 33.808 2.9l55.718-20.494 60.622 35 91-155.063-44.073-36.282z",
    style: {
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(263.754 372.875)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 60.621-35c14.349-8.284 19.266-26.632 10.982-40.98v-.001C63.317-90.33 44.97-95.246 30.621-86.962l-60.622 35",
    style: {
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(409.256 288.87)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 77.942-45c14.35-8.284 19.266-26.632 10.982-40.98-8.284-14.349-26.632-19.266-40.982-10.982L-30-51.961",
    style: {
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(379.255 236.908)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 60.622-35.001c14.349-8.284 19.266-26.632 10.981-40.98-8.285-14.349-26.632-19.265-40.981-10.981l-60.622 35",
    style: {
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(349.255 184.947)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 34.642-20c14.348-8.284 19.264-26.632 10.98-40.98v-.001C37.338-75.33 18.99-80.246 4.642-71.962l-34.642 20",
    style: {
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(319.255 132.985)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v0c-14.35 8.284-19.266 26.633-10.981 40.981l25 43.301C22.303 98.631 40.65 103.548 55 95.264c14.349-8.285 19.265-26.633 10.98-40.982l-25-43.301C32.696-3.368 14.349-8.284 0 0Z",
    style: {
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(152.233 103.694)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v0c-14.349 8.284-19.265 26.632-10.98 40.981l15 25.981C12.304 81.311 30.651 86.227 45 77.942c14.349-8.284 19.266-26.631 10.981-40.98l-15-25.981C32.696-3.368 14.349-8.284 0 0Z",
    style: {
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(204.194 73.694)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v0c-14.349 8.285-19.265 26.633-10.98 40.981l25 43.301c8.284 14.35 26.631 19.266 40.98 10.982 14.349-8.285 19.266-26.633 10.981-40.982l-25-43.301C32.696-3.367 14.349-8.284 0 0Z",
    style: {
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(48.31 163.694)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v0c-14.349 8.284-19.266 26.633-10.98 40.981l35 60.623c8.284 14.348 26.631 19.264 40.98 10.98 14.349-8.284 19.265-26.632 10.98-40.981l-35-60.622C32.696-3.367 14.349-8.284 0 0Z",
    style: {
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(100.272 133.694)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-73.633 42.513-85.121-158.701 46.768-27.002",
    style: {
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(173.754 390.195)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 34.641-20",
    style: {
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(254.614 101.023)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartner);
export default __webpack_public_path__ + "static/media/partner.75130f6505fb1f471321913d1302f29d.svg";
export { ForwardRef as ReactComponent };